<p
  class="fixed bottom-0 z-10 bg-secondaryBase text-tertiaryBase w-full h-[66px] px-16 py-4 font-size=14px"
>
  {{ text.texto_Footer}}
</p>
